import React, { ComponentProps } from "react"
import classNames from "utils/classNames"

type TitleProps = ComponentProps<"div"> & {}
export const Title = ({ children, className, ...props }: TitleProps) => {
  return (
    <span className={classNames("vt-trip-step-title", className)} {...props}>
      {children}
    </span>
  )
}

export interface ContentProps {
  className?: string
  children?: React.ReactNode
}
export const Content = ({ children, className }: ContentProps) => {
  return <section className={className}>{children}</section>
}

export type ProgressStepProps = ComponentProps<"li"> & {
  done?: boolean
  intent?: "success" | "warning" | "danger"
  lineStyle?: "dashed" | undefined
  sequenceId?: number | string
}
export const ProgressStep = ({
  children,
  done,
  intent,
  lineStyle,
  sequenceId,
  ...props
}: ProgressStepProps) => {
  return (
    <li
      data-sequence-id={sequenceId}
      className={classNames(`vt-step-${intent} vt-step-style-${lineStyle}`, {
        "vt-step-done": done,
      })}
      {...props}
    >
      {children}
    </li>
  )
}

export interface ProgressStepsWrapperProps {
  className?: string
  /**
   * This boolean determines wheter the progress steps will be vertical or horizontal
   */
  vertical?: boolean
  children?: React.ReactNode
}
export const ProgressStepsWrapper = ({
  className,
  children,
  vertical,
}: ProgressStepsWrapperProps) => {
  return (
    <div
      className={classNames(
        "vt-steps-wrapper",
        {
          "vt-steps-wrapper-vertical": vertical,
        },
        className
      )}
    >
      <ul>{children}</ul>
    </div>
  )
}
